// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8252 ? "793471a0" : chunkId) + "." + {"1646":"801b5db8d2d73320","4767":"dbb69b5dc3fcd04f","5430":"fc79e1933797593a","8252":"04aa79aabb3f2ea1"}[chunkId] + ".js";
};